$(document).ready(function () {

  $(document).on('click', '.user-brand-favorites .heart-token', function () {
    const brand_id = $(this).attr('brand_id')
    const partial = $(this).closest('.user-brand-favorites')
    const heartFaIcon = $(this).find('i')

    if (heartFaIcon.hasClass('filled')) {
      $.ajax({
        url: `/user_brand_favorites/${brand_id}`,
        method: 'delete'
      }).done(function (html) {
        partial.replaceWith(html)
      }).fail(function (response) {
        console.log('error -> ', response.responseJSON)
      });

    } else {
      $.post('/user_brand_favorites/',
        {
          brand_id: brand_id
        })
        .done(function (html) {
          partial.replaceWith(html)
        })
        .fail(function (response) {
          console.log('error -> ', response.responseJSON)
        })
    }

  })

  $(document).on('click', '.favorite-brands-filter', function () {
    const brandCards = $('.brands-page .brand-item')
    const checkbox = $(this).find("input[type='checkbox']")
    if (checkbox.is(':checked')) {
      filterFavBrands(brandCards, true)
    } else {
      filterFavBrands(brandCards, false)
    }
  })

})

const filterFavBrands = (brandCards, filter) => {
  brandCards.each(index => {
    const brandCard = brandCards[index]
    const notFavorited = !$(brandCard).find('.user-brand-favorites .heart-token i').hasClass('filled')
    if (filter) {
      if (notFavorited) {
        $(brandCard).addClass('d-none')
      }
    } else {
      if (notFavorited) {
        $(brandCard).removeClass('d-none')
      }
    }
  })
}